import { Controller } from "stimulus";

export default class extends Controller {
  static values = { publicKey : String, sessionId : String }
  initialize() {
    var stripe = Stripe(this.publicKeyValue);
    stripe.redirectToCheckout({ sessionId: this.sessionIdValue });
  }
}
